/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserExcludingFcmMessageIdFcmTokenWithRelations } from './userExcludingFcmMessageIdFcmTokenWithRelations';


/**
 * (tsType: Omit<UserCredentialsWithRelations, \'fcmMessageId\' | \'fcmToken\'>, schemaOptions: { includeRelations: true, exclude: [ \'fcmMessageId\', \'fcmToken\' ] })
 */
export interface UserCredentialsExcludingFcmMessageIdFcmTokenWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    id?: number;
    userId: number;
    authProvider: string;
    authId?: string;
    authToken?: string;
    password?: string;
    fcmTokenWeb?: string;
    isDefaultPassword?: boolean;
    redirectUrl?: string;
    emailVerifiedAt?: string;
    user?: UserExcludingFcmMessageIdFcmTokenWithRelations;
}

